@if(!previewFile) {
  <app-component-loader />
} @else {
  <dx-popup
    [(visible)]="showModal"
    [showCloseButton]="true"
    [showTitle]="true"
    [width]="width"
    [height]="height"
    [minWidth]="'700px'"
    [minHeight]="'500px'"
    [title]="previewFile.fileName"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    (onHidden)="onClose()"
  >
    <div *dxTemplate="let data of 'content'" class="h-full w-full p-2">        
      @if (previewFile.fileExtension == '.pdf') {
        <pdf-viewer
          [src]="previewFile.fileUrl"
          [rotation]="0"
          [original-size]="false"
          [show-all]="true"
          [fit-to-page]="false"
          [zoom-scale]="'page-width'"
          [stick-to-page]="false"
          [render-text]="true"
          [external-link-target]="'blank'"
          [autoresize]="true"
          [show-borders]="false"
          style="width: 100%; height: 100%;"
        ></pdf-viewer>
      } 
      @else if (
        previewFile.fileExtension == '.png' || 
        previewFile.fileExtension == '.jpg' || 
        previewFile.fileExtension == '.jpeg'
      ) {
        <div class="image-preview-container">
          <img
            [src]="previewFile.fileUrl | safe:'url'"
            [alt]="previewFile.fileName"
            [title]="previewFile.fileName"
            class="image-preview" 
          />
        </div>
      } @else {
        <p>
          <span>{{ "VALIDATIONS.PREVIEW-NOT-AVAILABLE" | translate }}</span>
          <a 
            [href]="previewFile.fileUrl" 
            target="_blank"
          >
            {{ "COMMON.DOWNLOAD" | translate }}
          </a>
        </p>
      }
    </div>
  </dx-popup>
}
